export const requisitos = [
  {
    titulo: "Nombre de la Institución de Afiliación",
    descripcion: "",
    enlace: "",
  },
  {
    titulo: "CUIT de la Institución de Afiliación",
    descripcion: "",
    enlace: "",
  },
  {
    titulo: "Dirección donde se encuentra la Institución de Afiliación",
    descripcion: "",
    enlace: "",
  },
  {
    titulo:
      "Correo electrónico de la dependencia de la Institución de Afiliación",
    descripcion: "",
    enlace: "",
  },
  {
    titulo: "Teléfono de contacto de la Institución de Afiliación",
    descripcion: "",
    enlace: "",
  },
  {
    titulo: "Datos personales del Investigador/a Principal ",
    descripcion:
      "Como el DNI, el correo electrónico de contacto, el número de teléfono de contacto, su domicilio, etc.",
    enlace: "",
  },
  {
    titulo: "Currículum Vitae Resumido",
    descripcion:
      "Deberá estar actualizado al año en curso. Se espera un máximo de 6 hojas. El documento tiene que estar en formato PDF. Modelo de Currículum Vitae Resumido: ",
    enlace:
      "https://docs.google.com/document/d/1rznn9zQoyIMQLRFzmsA4krPYSg3ujJcN/edit?usp=sharing&ouid=107520098035929869274&rtpof=true&sd=true",
  },
  {
    titulo: "Nombres de los patrocinantes, en caso de que aplique",
    descripcion: "",
    enlace: "",
  },
  {
    titulo:
      "Nota de aval de la institución de pertenencia del Investigador Principal. ",
    descripcion:
      "El documento tiene que estar en formato PDF. Modelo de aval: ",
    enlace:
      "https://docs.google.com/document/d/1aQyKlzkLC-YlSJ0bQJ4T98UG0oenL8j1/edit?usp=sharing&ouid=107520098035929869274&rtpof=true&sd=true",
  },
  {
    titulo:
      "Notas de autorización de las instituciones en donde se pretende realizar la investigación",
    descripcion:
      "El documento tiene que estar en formato PDF. Modelo de autorización escrita de la Dirección del Hospital o establecimiento donde se recolectarán datos: ",
    enlace:
      "https://docs.google.com/document/d/1YXC-bUEgs9oeBAIhUymdV6iuVbPWKVDx/edit?usp=sharing&ouid=107520098035929869274&rtpof=true&sd=true",
  },
  {
    titulo: "OPTATIVO: Dictámenes de otros Comités de Ética en Investigación",
    descripcion: "El documento tiene que estar en formato PDF.",
    enlace: "",
  },
  {
    titulo: "Resumen del proyecto (350 palabras máximo)",
    descripcion: "El documento tiene que estar en formato PDF.",
    enlace: "",
  },
  {
    titulo:
      "Protocolo de Investigación. Debe contener los 3 apartados: metodológico, ético y financiero.",
    descripcion:
      "El documento tiene que estar en formato PDF. Ejemplo de un modelo de Protocolo de investigación: ",
    enlace:
      "https://docs.google.com/document/d/1VRG4b6Tosd36cFraUTmEwnsj6aO0QVR7/edit?usp=sharing&ouid=107520098035929869274&rtpof=true&sd=true",
  },
];
